<template>
  <aside :class="classes.Description">
    <DSIcon
      v-if="expanded"
      :class="classes.DescriptionIcon"
      icon="info"
      size="md"
      aria-hidden="true"
      data-cy="ds-light-box__description-info"
    />
    <p
      v-if="expanded"
      data-cy="ds-light-box__description"
    >
      {{ description }}
    </p>
    <DSButton
      variant="ghost"
      size="xs"
      :prefix-icon="expanded ? 'cross-small' : 'info'"
      :aria-label="
        t(expanded ? 'design_system.light_box.hide_description' : 'design_system.light_box.show_description')
      "
      :aria-expanded="expanded"
      data-cy="ds-light-box__toggle-description"
      @click="onToggleDescriptionClick"
    />
  </aside>
</template>

<script setup lang="ts">
import { ref } from "vue";
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import { DS_LIGHT_BOX_CLASSES as classes } from "../constants/classes";

defineProps<{ description: string }>();
const expanded = ref(true);
const t = window.EasyLocale.getLocale;
const onToggleDescriptionClick = () => {
  expanded.value = !expanded.value;
};
</script>
